export default {
  searchQuery: {
    what: "",
    where: "",
    when: "",
    allowedDocs: [],
  },
  fachgruppen: [],
  results: [],
  currentResult: {},
  redirectedFromHome: false,
  apiResponse: {
    error: false,
    message: ""
  },
  auth: {
    authToken: null,
    currentUser: null,
    error: false
  },
  dashboardAppointments: [],
  reachedResultsEnd: false,
  blogItems: [],
  currentBlogItem: null,
  iframeDocs: [],
};



// WEBPACK FOOTER //
// ./src/state/state.js